// Get Network Orders
export const GET_NETWORK_ORDERS_REQUEST = 'GET_NETWORK_ORDERS_REQUEST';
export const GET_NETWORK_ORDERS_DONE = 'GET_NETWORK_ORDERS_DONE';
export const GET_NETWORK_ORDERS_FAILED = 'GET_NETWORK_ORDERS_FAILED';

// Operations
export const SET_NETWORK_ORDERS_STATUS_FILTER = 'SET_NETWORK_ORDERS_STATUS_FILTER';
export const SET_NETWORK_ORDERS_SEARCH_FILTER = 'SET_NETWORK_ORDERS_SEARCH_FILTER';
export const SET_NETWORK_ORDERS_DATE_RANGE_FILTER = 'SET_NETWORK_ORDERS_DATE_RANGE_FILTER';
export const NETWORK_ORDERS_SET_PAGE = 'NETWORK_ORDERS_SET_PAGE';
